import { axiosAuth } from "src/redux/api/common";
import { EditHealthReportFormValues, HealthReportdata } from "../schema/health-report.schema";
import { PRODUCT_BASE_URL } from "src/redux/api/appConst";

export async function addHealthReport(
  values: HealthReportdata,
  customer_id: number,
  member_id: number,
) {
  const payload = {
    customer_id: customer_id,
    member_id: member_id,
    blood_pressure_systolic: values.blood_pressure_systolic ?? undefined,
    blood_pressure_diastolic: values.blood_pressure_diastolic ?? undefined,
    pulse_rate: values.pulse_rate ?? undefined,
    body_weight: values.body_weight ?? undefined,
    blood_sugar_random: values.blood_sugar_random ?? undefined,
    bmi: values.bmi ?? undefined,
    body_fat: values.body_fat ?? undefined,
    muscle_mass: values.muscle_mass ?? undefined,
    muscle_rate: values.muscle_rate ?? undefined,
    skeletal_muscle_mass: values.skeletal_muscle_mass ?? undefined,
    body_water: values.body_water ?? undefined,
    bone_mass: values.bone_mass ?? undefined,
    bmr: values.bmr ?? undefined,
    metabolic_age: values.metabolic_age ?? undefined,
    visceral_fat: values.visceral_fat ?? undefined,
    subcutaneous_fat: values.subcutaneous_fat ?? undefined,
    protein_mass: values.protein_mass ?? undefined,
    weight_witout_fat: values.weight_witout_fat ?? undefined,
    obesity_level: values.obesity_level ?? undefined,

    ideal_body_weight: values.ideal_body_weight ?? undefined,
    water_weight: values.water_weight ?? undefined,
    obesity_grade: values.obesity_grade ?? undefined,
    fat_mass: values.fat_mass ?? undefined,
    body_score: values.body_score ?? undefined,

    medical_history: values.medical_history ?? undefined,
    medication: values.medication ?? undefined,
    activity_level: values.activity_level ?? undefined,
  };

  const api = axiosAuth();
  const res = await api.post(`${PRODUCT_BASE_URL}/admin/health-reports`, payload);

  return res.data;
}

export const getHealthReports = async (memberId: number) => {
  const api = axiosAuth();

  const { data } = await api.get(`${PRODUCT_BASE_URL}/admin/health-reports?member_id=${memberId}`);

  return data.data.health_reports;
};

export const editHealthReport = async (reportId: string, values: Partial<EditHealthReportFormValues>) => {
  const api = axiosAuth();

  const { data } = await api.patch(
    `${PRODUCT_BASE_URL}/admin/health-reports/${reportId}`, values
  );
  
  return data;
}